@if (loading) {
    <div class="nav-link d-flex align-items-center">
        @if (loading) {
            <con-loader></con-loader>
        }
    </div>
} @if (!loading && hasUser) {
    <div class="nav-link d-flex align-items-center px-1">
        <div class="chip">
            <con-avatar [userId]="$safeNavigationMigration(user?.id)" [size]="32"></con-avatar>
            {{ user?.first_name }} {{ user?.last_name }}
        </div>
    </div>
} @if (!loading && hasUser) {
    <a class="nav-link d-flex align-items-center settings" [routerLink]="['/settings']" routerLinkActive="active" placement="bottom" ngbTooltip="Settings">
        <con-icon-by-name iconName="cog" [mutations]="['lg', 'fw']"></con-icon-by-name>
    </a>
} @if (!loading && hasUser) {
    <a class="nav-link d-flex align-items-center logout" (click)="logout()">
        <con-icon-by-name iconName="power-off" [mutations]="['lg', 'fw']"></con-icon-by-name>
    </a>
}